module.exports = __webpack_public_path__ + "img/next_log.f5b0d646.png";